<template>
  <div class="input-row" :class="{'disabled-input': disabled}">
    <div class="label">{{ label }}</div>
    <ColorPicker :color="color" @input="$emit('input', $event)"></ColorPicker>
  </div>
</template>

<script>
import ColorPicker from "./ColorPicker";
export default {
  components: {
    ColorPicker
  },
  data() {
    return {
      tmpColor: this.color
    };
  },
  props: ["label", "color", "disabled"]
};
</script>

<style scoped>
.input-row {
  display: flex;
  height: 40px;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
}

.label {
  flex-grow: 1;
  font-size: 13px;
}

.color-preview {
  width: 35px;
  height: 35px;
  border-radius: 3px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  outline: none;
  -webkit-appearance: none;
}
</style>